/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([], () => {
	const actionInfo = {
		supportsUndoRedo: true,
		refresh: {
			render: true
		}
	};

	class DeprecatedConditionalFormattingAPISpec {
		getAPISpec() {
			if (!this.apiSpec) {
				this.apiSpec = {
					name: 'conditional formatting API',
					events: {
						actions: {
							setConditionalFormattingEnabled: {
								eventName: 'condtionalFormattingEnabled',
								info: actionInfo,
								getUndoActions: () => [{
									params: [this.getAPI().getCondtionalFormattingEnabled()]
								}]
							},
							setPaletteId: {
								eventName: 'paletteId',
								info: actionInfo,
								getUndoActions: () => [{
									params: [this.getPaletteId()]
								}]
							},
							setRangeScale: {
								eventName: 'rangeScale',
								info: actionInfo,
								getUndoActions: () => [{
									params: [this.getRangeScale()]
								}]
							},
							setNumberOfRanges: {
								eventName: 'numberOfRanges',
								info: actionInfo,
								getUndoActions: () => [{
									params: [this.getNumberOfRanges()]
								}]
							},
							setStartValueForRange: {
								eventName: 'startValueForRange',
								info: actionInfo,
								getUndoActions: (args) => [{
									params: [this.getStartValueForRange(args[1]), args[1]]
								}]
							},
							setEndValueForRange: {
								eventName: 'endValueForRange',
								info: actionInfo,
								getUndoActions: (args) => [{
									params: [this.getEndValueForRange(args[1]), args[1]]
								}]
							},
							setColorIdForRange: {
								eventName: 'colorIdForRange',
								info: actionInfo,
								getUndoActions: (args) => [{
									params: [this.getColorIdForRange(args[1]), args[1]]
								}]
							},
							removeRange: {
								eventName: 'removeRange',
								info: actionInfo,
								getUndoActions: () => {
									return [{
										name: 'setConditionalFormatting',
										params:[this.getConditionalFormatting()]
									}];
								}
							},
							setConditionalFormatting: {
								eventName: 'conditionalFormatting',
								info: actionInfo,
								getUndoActions: () => [{
									params: [this.getConditionalFormatting()]
								}]
							},
							reverseColors: {
								eventName: 'reverseColors',
								info: actionInfo,
								getUndoActions: () => {
									return [{
										name: 'setConditionalFormatting',
										params:[this.getConditionalFormatting()]
									}];
								}
							},
							resetRanges: {
								eventName: 'resetRanges',
								info: actionInfo,
								getUndoActions: () => {
									return [{
										name: 'setConditionalFormatting',
										params:[this.getConditionalFormatting()]
									}];
								}
							},
							setShapeForRange: {
								eventName: 'shapeForRange',
								info: actionInfo,
								getUndoActions: (args) => [{
									params: [this.getShapeForRange(args[1]), args[1]]
								}]
							}

						}
					}
				};
			}
			return this.apiSpec;
		}
	}

	return DeprecatedConditionalFormattingAPISpec;
});
